var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1664_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04757 5.23828C8.28981 5.23828 7.56309 5.5393 7.02727 6.07512C6.49145 6.61094 6.19043 7.33766 6.19043 8.09542V12.8573C6.19043 13.6151 6.49145 14.3418 7.02727 14.8776C7.56309 15.4135 8.28981 15.7145 9.04757 15.7145L11.398 15.7135L13.0314 18.0278C13.1082 18.1363 13.2068 18.2275 13.321 18.2956C13.4351 18.3636 13.5623 18.4071 13.6942 18.423L13.8095 18.4307C14.0429 18.4306 14.2682 18.3448 14.4425 18.1896C14.6168 18.0344 14.7281 17.8206 14.7552 17.5888L14.7619 17.4783L14.7628 15.7135L15.7142 15.7145C16.472 15.7145 17.1987 15.4135 17.7345 14.8776C18.2704 14.3418 18.5714 13.6151 18.5714 12.8573V8.09542C18.5714 7.33766 18.2704 6.61094 17.7345 6.07512C17.1987 5.5393 16.472 5.23828 15.7142 5.23828H9.04757Z",
    stroke: "#8F9195",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19035 12.8583L4.28558 14.763V10.9535H3.42273C2.92132 10.9535 2.44013 10.7559 2.08354 10.4034C1.72695 10.0509 1.52373 9.57201 1.51796 9.07064L1.4513 3.35635C1.4484 3.10438 1.49553 2.85434 1.58995 2.6207C1.68438 2.38707 1.82422 2.1745 2.00139 1.9953C2.17855 1.8161 2.38951 1.67384 2.62204 1.57675C2.85458 1.47966 3.10407 1.42967 3.35606 1.42969H11.9046C12.4098 1.42969 12.8943 1.63037 13.2515 1.98758C13.6087 2.34479 13.8094 2.82928 13.8094 3.33445V5.23921",
    stroke: "#8F9195",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1664_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThread);
export default __webpack_public_path__ + "static/media/thread.9835381a0790d84cadf37c93a9c90352.svg";
export { ForwardRef as ReactComponent };